export default __webpack_public_path__ + "static/media/cube.9ad9a389.glb";